export const SOLD_GROUP_LINKS = {
  BASE: "/app/sold-list",
  DETAILS: "/app/sold-list/:draftId",
};
